;(() => {
  const ERROR_CLASS = "field-container_error"

  function showFieldMessage(element, message) {
    const container = element.closest(".field-container")
    const errorEl = container?.querySelector("[data-field-error]")

    container?.classList.add(ERROR_CLASS)

    if (errorEl) {
      errorEl.textContent = message
      errorEl.classList.remove("hidden")
    }
  }

  /**
   * Show field error styling and message (blocks form submission)
   * @param {HTMLElement} element - The input/select element with the error
   * @param {string} message - The error message to display
   */
  function showFieldError(element, message) {
    showFieldMessage(element, message)
    element.setCustomValidity(message)
  }

  /**
   * Show field warning styling and message (non-blocking)
   * Unlike showFieldError, this does NOT call setCustomValidity,
   * so it won't block form submission. Use for suggestions like email typo hints.
   * @param {HTMLElement} element - The input/select element with the warning
   * @param {string} message - The warning message to display
   */
  function showFieldWarning(element, message) {
    showFieldMessage(element, message)
  }

  /**
   * Clear field error styling and message
   * @param {HTMLElement} element - The input/select element to clear error from
   */
  function clearFieldError(element) {
    const container = element.closest(".field-container")
    const errorEl = container?.querySelector("[data-field-error]")

    container?.classList.remove(ERROR_CLASS)

    if (errorEl) {
      errorEl.textContent = ""
      errorEl.classList.add("hidden")
    }

    element.setCustomValidity("")
  }

  window.HB = window.HB || {}
  window.HB.showFieldError = showFieldError
  window.HB.showFieldWarning = showFieldWarning
  window.HB.clearFieldError = clearFieldError
})()
